import React from 'react';
import { Table } from 'react-bootstrap';
import dayjs from 'dayjs';
import _ from 'lodash';

const SummarySection = ({systems, pages, date}) => {
    const {createdAt_gte , createdAt_lt} = date;
    // diff date
    const diffDays = dayjs(createdAt_lt).diff(dayjs(createdAt_gte), "days");
    const tableData = [
        {
            label: 'ຈຳນວນ',
            ລະບົບ: systems?.amount || 0,
            ເພສ: pages?.amount || 0,
            ວັນທີ: diffDays+1 || 0,
        },
        {
            label: 'ລາຍລະອຽດ',
            ລະບົບ: systems?.listName || '',
            ເພສ: pages?.listName || '',
            ວັນທີ: `${createdAt_gte} - ${createdAt_lt}`,
        }
    ];
    
    return (
        <Table responsive striped bordered hover>
            <thead className="bg-light">
            <tr>
                <th style={{ minWidth: '120px', color: '#0d6efd'}}></th>
                <th style={{ minWidth: '120px', color: '#0d6efd' }}>ລະບົບ</th>
                <th style={{ minWidth: '120px', color: '#0d6efd' }}>ເພສ</th>
                <th style={{ minWidth: '120px', color: '#0d6efd' }}>ວັນທີ</th>
            </tr>
            </thead>
            <tbody>
                {!_.isEmpty(tableData) ? tableData.map((row, index) => (
                    <tr key={index}>
                    <td style={{ color: '#0d6efd' }}>{row.label}</td>
                    <td>{row?.ລະບົບ}</td>
                    <td>{row?.ເພສ}</td>
                    <td>{row?.ວັນທີ}</td>
                    </tr>
                )) : <p>ບໍ່ພົບຂໍມູນ...</p> }
            </tbody>
        </Table>
    );
}

export default SummarySection